var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurgerW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tdesign:menu-application"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 4.49683H9V8.99683H4.5V4.49683ZM15.75 4.49683H20.25V8.99683H15.75V4.49683ZM27 4.49683H31.5V8.99683H27V4.49683ZM4.5 15.7468H9V20.2468H4.5V15.7468ZM15.75 15.7468H20.25V20.2468H15.75V15.7468ZM27 15.7468H31.5V20.2468H27V15.7468ZM4.5 26.9968H9V31.4968H4.5V26.9968ZM15.75 26.9968H20.25V31.4968H15.75V26.9968ZM27 26.9968H31.5V31.4968H27V26.9968Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerW);
export default __webpack_public_path__ + "static/media/burger_w.21d9718d2e8b9663e857970ffd8ef035.svg";
export { ForwardRef as ReactComponent };